module.exports = __webpack_public_path__ + "img/border-how-to.bbd4bb1f.png";